import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ContentLoader } from '@frontend/design-system';
import { useScheduleRequestDetails } from '../hooks/use-schedule-request-details';
import { ScheduleRequestDetails } from './ScheduleRequestDetails';
import { ScheduleRequestContentWrapper } from './types';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ScheduleRequestModal = ({
  showWritebackWarning,
  wrapper: Wrapper,
}: {
  showWritebackWarning: boolean;
  wrapper: ScheduleRequestContentWrapper;
}) => {
  const scheduleRequestDetailsProps = useScheduleRequestDetails();
  const { scheduleRequestModalProps, isLoading, handleCloseScheduleRequestModal } = scheduleRequestDetailsProps;

  return (
    <ScheduleRequestDetails {...scheduleRequestDetailsProps}>
      <Wrapper modalProps={scheduleRequestModalProps} onClose={handleCloseScheduleRequestModal}>
        {showWritebackWarning && <ScheduleRequestDetails.WritebackWarningBanner />}
        <ScheduleRequestDetails.Header />
        <Wrapper.Content>
          <ContentLoader show={isLoading} />
          <ScheduleRequestDetails.Body />
          <ScheduleRequestDetails.Footer />
        </Wrapper.Content>
      </Wrapper>
    </ScheduleRequestDetails>
  );
};
